
import { AllyProjectile } from '../types/entities';

export const drawAllyProjectiles = (ctx: CanvasRenderingContext2D, projectiles: AllyProjectile[]) => {
    projectiles.forEach(p => {
        ctx.save();
        ctx.translate(p.x + p.width/2, p.y + p.height/2);
        
        if (p.type === 'MIRA_WAVE') {
            // MIRA: Vertical Crescent Wave (Pink)
            // Rotate to match velocity
            // The drawing is oriented horizontally (Wave front facing Right is 0 deg? No, let's assume it faces Up)
            // The drawing below draws a crescent where -h is Up.
            // So 0 rotation = Face Up.
            // Math.atan2(vy, vx) returns angle where 0 = Right, -PI/2 = Up.
            // So we need to rotate by angle + PI/2.
            const angle = Math.atan2(p.vy, p.vx);
            ctx.rotate(angle + Math.PI / 2);
            
            ctx.globalAlpha = p.life / 80;
            const grad = ctx.createLinearGradient(-p.width/2, 0, p.width/2, 0);
            grad.addColorStop(0, "rgba(255, 0, 255, 0)");
            grad.addColorStop(0.2, "rgba(236, 72, 153, 1)"); // Pink-500
            grad.addColorStop(1, "rgba(255, 255, 255, 0)");
            
            ctx.fillStyle = grad;
            ctx.shadowColor = '#ec4899';
            ctx.shadowBlur = 15;

            // Draw Crescent Shape
            ctx.beginPath();
            const w = p.width;
            const h = p.height;
            // Simplified crescent drawing centered at 0,0
            ctx.moveTo(-w/2, 0); 
            ctx.quadraticCurveTo(0, -h, w/2, 0); 
            ctx.lineTo(w/2 + 20, 0); // Tip
            ctx.quadraticCurveTo(0, h * 1.5, -w/2, 0);
            ctx.fill();

            // Inner lines
            ctx.strokeStyle = "rgba(255,255,255,0.8)"; ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.moveTo(-w/2 + 10, 0);
            ctx.quadraticCurveTo(0, -h/2, w/2 - 10, 0);
            ctx.stroke();

        } else if (p.type === 'ZOEY_MISSILE') {
            // ZOEY: Cyan Tech Daggers
            // Rotate based on velocity
            const angle = Math.atan2(p.vy, p.vx);
            ctx.rotate(angle + Math.PI/2); // Adjust so 0 is up

            ctx.globalAlpha = p.life / 60;
            
            ctx.fillStyle = "#06b6d4"; // Cyan-500
            ctx.shadowColor = "#06b6d4"; ctx.shadowBlur = 10;
            
            // Draw Dagger/Missile shape
            ctx.beginPath();
            ctx.moveTo(0, -20); // Tip
            ctx.lineTo(5, 5);
            ctx.lineTo(0, 0);
            ctx.lineTo(-5, 5);
            ctx.closePath();
            ctx.fill();

            // Trail
            ctx.fillStyle = "rgba(255,255,255,0.8)";
            ctx.beginPath();
            ctx.moveTo(0, 0);
            ctx.lineTo(2, 10);
            ctx.lineTo(-2, 10);
            ctx.fill();
        }

        ctx.restore();
    });
};
